import { render, staticRenderFns } from "./manage-patient-notes.vue?vue&type=template&id=0cb1d3f2&scoped=true"
import script from "./manage-patient-notes.vue?vue&type=script&lang=js"
export * from "./manage-patient-notes.vue?vue&type=script&lang=js"
import style0 from "./manage-patient-notes.vue?vue&type=style&index=0&id=0cb1d3f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb1d3f2",
  null
  
)

export default component.exports